import {
  ASSIGMENTS_ORDER_DETAIL,
  ASSIGMENTS_ORDER_DETAIL_ERROR,
  CLEAN_ASSIGMENTS_ORDER_DETAIL,
  CLEAN_ASSIGMENTS_ORDER_DETAIL_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function createOrderLineAssignmentReducer(state = initialState, action) {
  switch (action.type) {
    case ASSIGMENTS_ORDER_DETAIL:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case ASSIGMENTS_ORDER_DETAIL_ERROR:
      return {
        ...state,
        loaded: true,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_ASSIGMENTS_ORDER_DETAIL:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_ASSIGMENTS_ORDER_DETAIL_ERROR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
